<template>
  <div class="rounded shadow-xs">
    <div class="rounded bg-white shadow-lg overflow-hidden">
      <ValidationObserver ref="observer" v-slot="{ invalid, handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="p-4 lg:p-6 bg-gray-100">
            <h3 class="text-lg">Basic Details</h3>
            <p class="text-sm text-gray-600">Change your project's basic details</p>
          </div>
          <div class="p-4 lg:p-6 space-y-4 lg:space-y-6">
            <ValidationProvider rules="required" name="name" tag="div" vid="name">
              <template #default="{ errors }">
                <BaseFormGroup class="max-w-lg">
                  <BaseFormLabel for="name"> Name * </BaseFormLabel>
                  <BaseFormInput id="name" v-model="data.name" :disabled="isPending" />
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>

            <ValidationProvider rules="max:255" name="description" tag="div" vid="description">
              <template #default="{ errors }">
                <BaseFormGroup class="max-w-lg">
                  <BaseFormLabel for="description"> Description </BaseFormLabel>
                  <BaseFormTextarea
                    id="description"
                    v-model="data.description"
                    :disabled="isPending"
                  />
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </div>
          <div class="p-4 lg:p-6">
            <BaseButton
              :primary="isIdle || isPending"
              :success="isResolved"
              :danger="isRejected"
              :disabled="invalid"
            >
              <span v-if="isIdle">Submit</span>
              <span v-else-if="isPending">Please wait...</span>
              <span v-else-if="isResolved">Success!</span>
              <span v-else>Failed!</span>
            </BaseButton>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'BasicDetailsForm',

  mixins: [veeValidateErrorsMixin],

  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      data: {
        name: '',
        description: '',
      },
      status: 'idle',
    };
  },

  computed: {
    isIdle() {
      return this.status === 'idle';
    },
    isPending() {
      return this.status === 'pending';
    },
    isResolved() {
      return this.status === 'resolved';
    },
    isRejected() {
      return this.status === 'rejected';
    },
  },

  watch: {
    project(project) {
      this.setData(project || {});
    },
  },

  created() {
    this.setData(this.project || {});
  },

  methods: {
    setData({ name = '', description = '' }) {
      this.data.name = name;
      this.data.description = description;
    },
    async onSubmit() {
      if (!this.isIdle) {
        return;
      }
      this.setPending();
      try {
        await this.$store.dispatch({
          type: 'ui/projects/update',
          projectUuid: this.project.uuid,
          formData: this.data,
        });
        this.setResolved();
      } catch (error) {
        if (error && error.status === 422) {
          this.onUnprocessableEntityError(error.data.errors);
        }
        this.setRejected();
      } finally {
        setTimeout(() => {
          this.setIdle();
        }, 1500);
      }
    },
    setIdle() {
      this.status = 'idle';
    },
    setPending() {
      this.status = 'pending';
    },
    setResolved() {
      this.status = 'resolved';
    },
    setRejected() {
      this.status = 'rejected';
    },
    onUnprocessableEntityError(errors) {
      this.observer = this.$refs.observer;
      this.addServerErrors(errors);
    },
  },
};
</script>
